import Slider from "react-slick";
import { MdArrowCircleLeft, MdArrowCircleRight } from "react-icons/md";
import Styles from "./LandingPage.module.css";

export default function Scroller({ TestmonialRef, Testimonials_Model }) {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: window.innerWidth <= 790 ? 1 : 3,
    slidesToScroll: 1,
    // nextArrow: <SliderArrow1 />,
    // prevArrow: <SliderArrow2 />,
  };
  return (
    <>
      <Slider ref={TestmonialRef} {...settings}>
        {/* {Testimonials_Model?.map((el, index) => ( */}
        <div>
          <div className={Styles.Scroller}>
            <h4>Testifyi</h4>
            <p>
              <b>Free Counseling Session:</b>
            </p>
            <p>Personalized guidance to explore study abroad options.</p>
          </div>
        </div>
        <div>
          <div className={Styles.Scroller}>
            <h4>Testifyi</h4>
            <p>
              <b>Free Counseling Session:</b>
            </p>
            <p>Personalized guidance to explore study abroad options.</p>
          </div>
        </div>
        <div>
          <div className={Styles.Scroller}>
            <h4>Testifyi</h4>
            <p>
              <b>Free Counseling Session:</b>
            </p>
            <p>Personalized guidance to explore study abroad options.</p>
          </div>
        </div>
        <div>
          <div className={Styles.Scroller}>
            <h4>Testifyi</h4>
            <p>
              <b>Free Counseling Session:</b>
            </p>
            <p>Personalized guidance to explore study abroad options.</p>
          </div>
        </div>
        <div>
          <div className={Styles.Scroller}>
            <h4>Testifyi</h4>
            <p>
              <b>Free Counseling Session:</b>
            </p>
            <p>Personalized guidance to explore study abroad options.</p>
          </div>
        </div>
        {/* ))} */}
      </Slider>
      <div style={{ padding: "20px 0" }} className={Styles.SliderArrow}>
        <span onClick={() => TestmonialRef?.current?.slickPrev()}>
          <MdArrowCircleLeft />
        </span>
        <span onClick={() => TestmonialRef?.current?.slickNext()}>
          <MdArrowCircleRight />
        </span>
      </div>
    </>
  );
}
